import React from 'react';
import { Sidebar } from '../components/Sidebar';
import { TopBar } from '../components/TopBar';
import { FloatingAssistant } from '../components/FloatingAssistant';
import { usePermission } from '../hooks/usePermission';

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  // The assistant answers from quotations data among everything else, so
  // POST /api/chat/message is gated on QUOTATIONS view — it used to answer any
  // account with a login. This layout renders on EVERY authenticated page, so
  // without the same condition here a role that lacks the permission would see
  // the button on every screen and get a 403 from it every time. Hidden rather
  // than disabled: there is nothing the user can do to earn it themselves.
  const { canView: canUseAssistant } = usePermission('quotations');

  return (
    <div className="h-screen w-screen max-w-full bg-brand-bg flex flex-col overflow-hidden">
      {/* Global top header bar */}
      <TopBar />

      {/* Main area: sidebar on the left, content on the right */}
      <div className="flex flex-1 min-h-0 min-w-0">
        <Sidebar />

        {/* Allow page scroll; bottom safe-area for notched devices. The wrapper lets a document that opens as a
            page (Modal asPage) cover this area only, never the sidebar. */}
        <div className="relative flex flex-1 min-h-0 min-w-0">
          <main
            className="flex-1 min-h-0 min-w-0 overflow-auto bg-brand-bg"
            style={{ paddingBottom: 'env(safe-area-inset-bottom, 0)' }}
          >
            {children}
          </main>
          <div id="page-overlay-root" className="pointer-events-none absolute inset-0 z-30" />
        </div>
      </div>

      {/* USC Copilot — floating AI assistant, on every page the caller may use it on */}
      {canUseAssistant && <FloatingAssistant />}
    </div>
  );
};
